import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['overlay', 'slider'];
  static requiredTargets = [];

  static values = {
    clicked: Number,
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 550
    }
  };

  // TARGETS
  declare overlayTarget: HTMLDivElement;
  declare sliderTarget: HTMLDivElement;

  // VALUES
  declare clickedValue: number;
  declare widthValue: number;
  declare heigthValue: number;

  connect() {
    this.slide = this.slide.bind(this);
    this.slideMove = this.slideMove.bind(this);
    this.slideMove = this.slideMove.bind(this);
    this.slideFinish = this.slideFinish.bind(this);
  }

  slideReady(e) {
    e.preventDefault();
    this.clickedValue = 1;

    window.addEventListener('mousemove', this.slideMove);
    window.addEventListener('touchmove', this.slideMove);
    window.addEventListener('mouseup', this.slideFinish);
    window.addEventListener('touchend', this.slideFinish);
  }

  slideFinish() {
    this.clickedValue = 0;

    window.removeEventListener('mousemove', this.slideMove);
    window.removeEventListener('touchmove', this.slideMove);
    window.removeEventListener('mouseup', this.slideFinish);
    window.removeEventListener('touchend', this.slideFinish);
  }

  slideMove(e) {
    let pos;
    /* if the slider is no longer clicked, exit this function: */
    if (this.clickedValue == 0) {
      return false;
    }

    pos = this.getCursorPos(e);

    if (pos < 0) {
      pos = 0;
    }
    if (pos > this.widthValue) {
      pos = this.widthValue;
    }

    this.slide(pos);
  }

  getCursorPos(e) {
    e = e.changedTouches ? e.changedTouches[0] : e;

    const rect = this.overlayTarget.getBoundingClientRect();
    const x = e.pageX - rect.left - window.pageXOffset;

    return x;
  }

  slide(x) {
    const slider = this.sliderTarget;
    const overlay = this.overlayTarget;

    overlay.style.width = x + 'px';
    slider.style.left = overlay.offsetWidth - slider.offsetWidth / 2 + 'px';
  }
}
